
import { Vue } from "vue-class-component";

export default class Descending extends Vue {}
